import React from "react";

function Edit3Icon({ fill, ...restProps }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={fill ?? ""}
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M11.649 1.199a2.18 2.18 0 0 0-.909.383c-.169.122-8.929 8.875-9.079 9.072a2.431 2.431 0 0 0-.302.59c-.087.252-.11.584-.101 1.463.009.812.01.829.073.952a.772.772 0 0 0 .349.345c.119.062.125.063 1.093.063 1.038 0 1.106-.007 1.437-.138.411-.163.291-.049 4.985-4.738 2.44-2.437 4.49-4.506 4.556-4.597.153-.213.261-.437.335-.695.078-.271.083-.834.011-1.099a2.193 2.193 0 0 0-1.518-1.548c-.216-.062-.725-.091-.93-.053m.684 1.56a.669.669 0 0 1 .244.902c-.037.062-2.027 2.071-4.422 4.465-3.416 3.414-4.381 4.363-4.475 4.406-.103.046-.177.054-.527.054l-.406.001v-.407c.001-.35.008-.423.055-.527.042-.094.989-1.056 4.392-4.461a711.952 711.952 0 0 1 4.416-4.398.684.684 0 0 1 .723-.035M7.79 12.617a.764.764 0 0 0-.461.396c-.049.095-.062.162-.062.32 0 .31.133.526.413.671l.12.063h6.4l.133-.071a.692.692 0 0 0 .4-.663c0-.309-.133-.525-.413-.671l-.12-.062-3.16-.004c-1.988-.003-3.193.005-3.25.021"
        fill={fill ?? ""}
      />
    </svg>
  );
}

export default Edit3Icon;
